<template>
  <div>
    <h3></h3>
    <h3 v-if="!iscom">天天畅聊</h3>
    <el-form :inline="true" class="demo-form-inline" :loading="loading" size="mini">
      <el-form-item label="会话ID">
        <el-input placeholder="会话ID" v-model="filter.conversationId"></el-input>
      </el-form-item>
      <el-form-item label="甲方ID">
        <el-input placeholder="甲方ID" v-model="filter.partyA"></el-input>
      </el-form-item>
      <el-form-item label="乙方ID">
        <el-input placeholder="乙方ID" v-model="filter.receiverUserId"></el-input>
      </el-form-item>
      <el-form-item label="乙方手机号">
        <el-input placeholder="乙方手机号" v-model="filter.phoneNumber"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="fetch(1)">查询</el-button>
        <el-button type="primary" size="mini" @click="rest()">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" size="mini">
      <el-table-column prop="id" label="序号"  width="50"></el-table-column>
      <el-table-column prop="conversationId" label="会话ID"></el-table-column>
      <el-table-column prop="userId" label="甲方ID"></el-table-column>
      <el-table-column prop="partyAName" label="甲方昵称"></el-table-column>
      <el-table-column prop="receiverUserId" label="乙方ID"></el-table-column>
      <el-table-column prop="nickname" label="乙方昵称"></el-table-column>
      <el-table-column prop="phoneNumber" label="乙方手机号"></el-table-column>
      <el-table-column prop="createTime" label="使用时间"></el-table-column>
    </el-table>
    <br />
    <div>
      <el-pagination background layout="prev, pager, next" :page-size="limit" @current-change="(i) => (pageNum = i)"
        :page-count="pageNum" :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import map from "../../../datamap";
import api from "../../api";
// import newApi from "@/newApi/bean.js";

let { prop } = api;
export default {
  name: "partyBorder",
  props: {
    iscom: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    eqId: {
      default: () => {
        return ''
      }
    }
  },
  data() {
    return {
      map,
      loading: true,
      types: {},
      filter: {
        conversationId: "",
        type: 0,
        userId: '',
        receiverUserId: '',
        phoneNumber: '',
      },
      list: [],
      total: 0,
      pageNum: 1,
      limit: 30,
      chargingWay: {
        0: "按小时计费",
        1: "项目制",
      },
    };
  },
  watch: {
    pageNum() {
      this.fetch();
    },
  },
  methods: {
    rest() {
      this.filter = {
        conversationId: "",
        type: 0,
        partyA: '',
        receiverUserId: '',
        phoneNumber: '',
      }
      this.fetch(1);
    },
    async fetch(num) {
      if (num == 1) {
        this.pageNum = 1;
      }
      this.filter.type = this.iscom ? 1 : 0
      this.filter.eqId = this.eqId ? this.eqId : null
      
      this.filter.pageNum = this.pageNum
      this.filter.limit = this.limit
      let res = await prop.qryChatLog(this.filter);
      this.list = res.data.data;
      this.total = res.data.pageinfo.totalCount;
    },
    async getTypes() {
      let res = await bean.types();
      this.types = res.data.data;
    },

  },
  mounted() {
    this.fetch(1);
  },
};
</script>
<style></style>


// WEBPACK FOOTER //
// src/views/prop/partyA/daily.vue